<template>
  <layout-vertical>

    <membership-gate>
      <router-view :key="$route.fullPath" />
    </membership-gate>

    <template #navbar="{ toggleVerticalMenuActive, isVerticalMenuActive }">
      <navbar
        :toggle-vertical-menu-active="toggleVerticalMenuActive"
        :is-vertical-menu-active="isVerticalMenuActive"
      />
    </template>

    <app-customizer
      v-if="false"
      slot="customizer"
    />
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'
import MembershipGate from '@/components/MembershipGate.vue'

export default {
  components: {
    MembershipGate,
    AppCustomizer,
    LayoutVertical,
    Navbar,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
